import Model from '../orm/Model'

import Student from './Student'

export default class Excuse extends Model {
    
    static entity = 'excuses'

    static fields() {
        return {
            id: this.attr(null),
            student_id: this.number(),
            student: this.belongsTo(Student, 'student_id'),
            date: this.attr(null),
            notes: this.string('').nullable(),
            attendable_id: this.number(),
            attendable_type: this.string(),
            attendable_title: this.string('–')
        }
    }

    static graphql = {
        create: {
            type: 'createExcuse',
            parameters: {
                date: 'String!',
                student_id: 'Int!',
                attendable_id: 'Int!',
                attendable_type: 'String!',
                notes: 'String'
            }
        },
        remove: {
            type: 'removeExcuse',
            parameters: {
                id: 'Int!'
            }
        }
    }
}